import { FaHandshake, FaProjectDiagram, FaBullseye } from "react-icons/fa";

const WhoWeAre = () => {
  return (
    <section className="who-we-are-section">
      {/* Heading */}
      <h2 className="who-we-are-title">Who We Are</h2>

      {/* Cards Container */}
      <div className="who-we-are-cards">
        
        {/* Card 1 */}
        <div className="who-card">
          <div className="who-icon">
            <FaHandshake />
          </div>
          <h3>Specialized Expertise</h3>
          <p>
            Leading loan facilitation company dedicated to serving the Mumbai
            Metropolitan Region with personalized financial solutions.
          </p>
        </div>

        {/* Card 2 */}
        <div className="who-card">
          <div className="who-icon">
            <FaProjectDiagram />
          </div>
          <h3>Trusted Network</h3>
          <p>
            Strategic partnerships with reputed banks and NBFCs, ensuring you get
            the best financing options available.
          </p>
        </div>

        {/* Card 3 */}
        <div className="who-card">
          <div className="who-icon">
            <FaBullseye />
          </div>
          <h3>Focused Solutions</h3>
          <p>
            Comprehensive offerings across home loans, mortgage loans, and
            business loans tailored to your unique needs.
          </p>
        </div>

      </div>
    </section>
  );
};

export default WhoWeAre;
